import { render, staticRenderFns } from "./ComplaintSectorDelete.vue?vue&type=template&id=3b62b1c6&"
import script from "./ComplaintSectorDelete.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports